// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__36EGq","title":"Images90_title__1oqQi","images":"Images90_images__34OJP"};